<section>
  <h2 class="bl-font-size--32 bl-font-weight--900 bl-font-color--black bl-margin-bottom--16">
    {{'OaoBeneficiaryReview/heading'|dictionary}}
  </h2>
  <div id="primary-beneficiary-allocation"
    [attr.data-automation-id]="'beneficiary-primary-allocation'" 
    *ngIf="primaryBeneficiaryList && primaryBeneficiaryList.length > 0"
    class="dx-workflow-card bl-block-module bl-margin-top--16">
    
    <div class="bl-display--flex">
      <h3
        class="bl-font-weight--900 bl-font-color--base bl-font-size--22 bl-padding-top--8 bl-padding-left--8">
        {{'OaoBeneficiaryReview/primary-sub-heading'|dictionary}} </h3>
      <p class="bl-align-self--center bl-margin--0 bl-margin-top--24 bl-margin-top-sm--0 bl-flex--auto">
        <button (click)="redirectToEdit()" type="button" 
          class="bl-button bl-button-small bl-button-reverse bl-float--right">
          <span class="bl-font-color--primary ">
            <span class="bl-font-size--14 cu-icons cu-edit bl-margin-right--4">
            </span>  
            <span>{{ 'OaoBeneficiaryReview/edit' | dictionary }}</span>
            <span class="bl-screen-reader-only">
              {{'OaoBeneficiaryReview/primary-sub-heading'|dictionary}}
            </span>
          </span>
        </button>
      </p>   
    </div>
    
    <div class="flexbox-format" *ngFor="let item of primaryBeneficiaryList;let i = index;">
      <div class="bl-margin-bottom--16 inline bl-padding-top--8
      bl-padding-left--8">
        <label for="type-{{i}}" class="bl-label bl-font-size--14 ">
          Beneficiary {{item.acutalIndex+1}} - {{item.type.value}}
        </label>
        <div class=" bl-font-size--14">{{item.allocation.value}}</div>
      </div>
    </div>
  </div>

  <div id="oao-beneficiary-contingent-allocation" *ngIf="contigentBeneficiaryList && contigentBeneficiaryList.length > 0"
    [attr.data-automation-id]="'beneficiary-contingent-allocation'"
    class="dx-workflow-card bl-block-module bl-margin-top--16">
        <div class="bl-display--flex">
          <h3
            class="bl-font-weight--900 bl-font-color--base bl-font-size--22 bl-padding-top--8 bl-padding-left--8">
            {{'OaoBeneficiaryReview/contingent-sub-heading'|dictionary}} </h3>
          <p class="bl-align-self--center bl-margin--0 bl-margin-top--24 bl-margin-top-sm--0 bl-flex--auto">
            <button type="button" (click)="redirectToEdit()"
            class="bl-button bl-button-small bl-button-reverse bl-float--right">
              <span class="bl-font-color--primary ">
                <span class="bl-font-size--14 cu-icons cu-edit bl-margin-right--4">
                </span>  
                <span>{{ 'OaoBeneficiaryReview/edit' | dictionary }}</span>
                <span class="bl-screen-reader-only">
                  {{'OaoBeneficiaryReview/contingent-sub-heading'|dictionary}}
                </span>
              </span>
            </button>
          </p>
        </div>
    
    <div class="flexbox-format" *ngFor="let item of contigentBeneficiaryList;let i = index;">
      <div class="bl-margin-bottom--16 inline bl-padding-top--8
      bl-padding-left--8">
        <label for="type-{{i}}" class="bl-label bl-font-size--14">
          Beneficiary {{item.acutalIndex+1}} - {{item.type.value}}
        </label>
        <div class="bl-font-size--14">{{item.allocation.value}} </div>
      </div>
    </div>
  </div>
</section>